module.exports = __webpack_public_path__ + "img/setting.8db4d23f.svg";